import { Fragment, useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { Link, useNavigate } from "react-router";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loading from "../../Common/Loading";
import SidePanel from "../../Components/SidePanel/SidePanel";
import Paginations from "../../Components/Paginations/Paginations";
import FilePageService from "../../API/FilePage/FilePageService";
import AddGuaranteeBasis from "./AddGuaranteeBasis";
import EditGuaranteeBasis from "./EditGuaranteeBasis";

const GuaranteeBasis = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [guaranteeBasisList, setGuaranteeBasisList] = useState([]);
  const [logoImageShow, setLogoImageShow] = useState("");
  const [rightPanelThemeColor, setRightPanelThemeColor] = useState("#d9ebff");
  const [editGuaranteeBasisId, setEditGuaranteeBasisId] = useState("");
  const [editGuaranteeBasisStatus, setEditGuaranteeBasisStatus] = useState("");
  const [search, setSearch] = useState("");
  const [riskTypeFilter, setRiskTypeFilter] = useState("");
  const [updateGuaranteeBasisId, setUpdateGuaranteeBasisId] = useState("");
  const [updateGuaranteeBasisStatus, setUpdateGuaranteeBasisStatus] = useState("");
  const [deleteGuaranteeBasisId, setDeleteGuaranteeBasisId] = useState("");
  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [sort, setSort] = useState({ key: "created_at", value: "desc" });
  const [isRotated, setIsRotated] = useState(false);

  const [formShowAdd, setFormShowAdd] = useState(false);
  const handleFormShowAdd = () => setFormShowAdd(true);
  const handleFormCloseAdd = () => setFormShowAdd(false);

  const [formShowEdit, setFormShowEdit] = useState(false);
  const handleFormShowEdit = () => setFormShowEdit(true);
  const handleFormCloseEdit = () => setFormShowEdit(false);

  const [showmodal, setShowmodal] = useState(false);
  const handleModalShow = () => setShowmodal(true);
  const handleModalClose = () => {
    setShowmodal(false);
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const [riskTypeList, setRiskTypeList] = useState([]);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 3000); // Adjust time as needed
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  useEffect(() => {
    const userRole = JSON.parse(localStorage.getItem("userRole"));
    const token = localStorage.getItem("authToken");
    if (token && userRole.includes("Administrateur")) {
      const logo_image = JSON.parse(localStorage.getItem("logo_image"));
      const right_panel_color = JSON.parse(
        localStorage.getItem("right_panel_color")
      );
      setRightPanelThemeColor(right_panel_color);
      setLogoImageShow(logo_image);
      GuaranteeBasisList(search, sort, currentPage, editGuaranteeBasisStatus, riskTypeFilter);
      setEditGuaranteeBasisStatus("");
    } else {
      navigate("/");
    }
  }, [sort]);

  useEffect(() => {
    RiskTypeList();
  }, []);

  const RiskTypeList = async () => {
    try {
      const response = await FilePageService.risk_types_list();

      if (response.data.status) {
        setRiskTypeList(response.data.risk_types);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GuaranteeBasisList = async (search, sort, page = 1, status, riskType) => {
    setIsLoading(true);
    try {
      const useData = {
        search: search,
        sort: {
          key: sort.key,
          value: sort.value,
        },
        page,
        status: status,
        risk_type: riskType
      };

      const response = await FilePageService.guarantee_basis_index(useData);

      if (response.data.status) {
        setIsLoading(false);
        setGuaranteeBasisList(response.data.guarantee_basis.data);
        setCurrentPage(response.data.guarantee_basis.meta.current_page);
        setTotalPages(response.data.guarantee_basis.meta.last_page);
        setTotalRecord(response.data.guarantee_basis.meta.total);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const DeleteGuaranteeBasis = async () => {
    try {
      const response = await FilePageService.delete_guarantee_basis(
        deleteGuaranteeBasisId
      );

      if (response.data.status) {
        GuaranteeBasisList(search, sort, 1, "", "");
        handleCloseDeleteModal();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const HandleUpdateStatus = async () => {
    try {
      var useData = {
        status: updateGuaranteeBasisStatus == 1 ? "0" : "1",
      };

      const response = await FilePageService.guarantee_basis_status_update(
        updateGuaranteeBasisId,
        useData
      );

      if (response.data.status) {
        setEditGuaranteeBasisStatus("");
        GuaranteeBasisList(search, sort, currentPage, "", "");
        handleModalClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchChange = (search) => {
    setSearch(search);
    GuaranteeBasisList(search, sort, 1, editGuaranteeBasisStatus, riskTypeFilter);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchChange(search);
    }
  };

  const HandleFilterStatus = (status) => {
    setEditGuaranteeBasisStatus(status);
    GuaranteeBasisList(search, sort, 1, status, riskTypeFilter);
  };

  const HandleRiskTypeFilter = (risk_type) => {
    setRiskTypeFilter(risk_type);
    GuaranteeBasisList(search, sort, 1, editGuaranteeBasisStatus, risk_type);
  };

  const handleStatusChange = (id, status) => {
    setUpdateGuaranteeBasisId(id);
    setUpdateGuaranteeBasisStatus(status);
    handleModalShow();
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    GuaranteeBasisList(search, sort, page, editGuaranteeBasisStatus, riskTypeFilter); // Fetch data for the selected page
  };

  const handleClickRotate = (column) => {
    const direction =
      sort.key === column ? (sort.value === "desc" ? "asc" : "desc") : "asc";
    setSort({ key: column, value: direction });
    setIsRotated(!isRotated); // Toggle the class on click
  };

  const riskTypeOptions = Object.entries(riskTypeList).map(([key, label]) => ({
    value: key,
    label: label,
  }));

  return (
    <Fragment>
      <style>
        {" "}
        {` button.btn.btn-primary  { background-color: ${localStorage.getItem("button_color")
            ? JSON.parse(localStorage.getItem("button_color"))
            : "#e84455"
          } !Important};`}{" "}
      </style>

      <SidePanel
        sidebarLogo={`${process.env.REACT_APP_IMAGE_URL}/${logoImageShow}`}
      />

      <div
        className="dashboard-main-content user-management"
        style={{ backgroundColor: rightPanelThemeColor }}
      >
        <div className="top-header">
          <div className="mt-3 d-md-flex justify-content-between align-items-center">
            <h1 className="m-md-0 mb-3">Base de garantie</h1>
          </div>
        </div>

        <div className="table-wrapper mt-16">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <Form.Group
              className="relative"
              controlId="exampleForm.ControlInput1"
            >
              <Form.Control
                type="search"
                placeholder="Rechercher"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={handleKeyPress}
              />
              <div
                className="search-icon"
                style={{ cursor: "pointer" }}
                onClick={() => handleSearchChange(search)}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.7549 11.2549H11.9649L11.6849 10.9849C12.6649 9.84488 13.2549 8.36488 13.2549 6.75488C13.2549 3.16488 10.3449 0.254883 6.75488 0.254883C3.16488 0.254883 0.254883 3.16488 0.254883 6.75488C0.254883 10.3449 3.16488 13.2549 6.75488 13.2549C8.36488 13.2549 9.84488 12.6649 10.9849 11.6849L11.2549 11.9649V12.7549L16.2549 17.7449L17.7449 16.2549L12.7549 11.2549ZM6.75488 11.2549C4.26488 11.2549 2.25488 9.24488 2.25488 6.75488C2.25488 4.26488 4.26488 2.25488 6.75488 2.25488C9.24488 2.25488 11.2549 4.26488 11.2549 6.75488C11.2549 9.24488 9.24488 11.2549 6.75488 11.2549Z"
                    fill="#998f90"
                  />
                </svg>
              </div>
            </Form.Group>
            <div className="text-end mb-3">
              <Button
                onClick={() => handleFormShowAdd()}
                variant="primary"
              >
                Ajouter une base de garantie
              </Button>
            </div>
          </div>
          {isLoading ? (
            <Loading />
          ) : (
            <div className="table-wrap mt-24">
              <Table responsive hover>
                <thead>
                  <tr>
                    {/* <th>No.</th> */}
                    <th>
                      <div className="d-flex align-items-center">
                        <span>{t("nameLabel")}</span>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("name")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <div>
                          <Form.Select
                            aria-label="statusSelectAria"
                            value={riskTypeFilter}
                            onChange={(e) =>
                              HandleRiskTypeFilter(e.target.value)
                            }
                          >
                            <option value="">{t("Type de risque")}</option>
                            {riskTypeOptions?.map((data, index) => (
                              <option key={index} value={data.value}>
                                {data.label}
                              </option>
                            ))}
                          </Form.Select>
                        </div>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("risk_type")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <span>{t("Conditions")}</span>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("conditions")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <span>{t("Montant de la franchise")}</span>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("amount_franchise")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <span>{t("Description")}</span>
                        <Link
                          className={`sorting-icon ms-2`}
                          onClick={() => handleClickRotate("description")}
                        >
                          {sort.value === "asc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                            </svg>
                          )}

                          {sort.value === "desc" && (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                fill="black"
                                fillOpacity="0.5"
                              />
                              <path
                                d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </Link>
                      </div>
                    </th>
                    <th width={165} className="select-drop elips-dropdown">
                      <div className="d-flex align-items-center">
                        <div>
                          <Form.Select
                            aria-label="statusSelectAria"
                            value={editGuaranteeBasisStatus}
                            onChange={(e) => HandleFilterStatus(e.target.value)}
                          >
                            <option value="">{t("status")}</option>
                            <option value="0">{t("inActiveLabel")}</option>
                            <option value="1">{t("activeLabel")}</option>
                          </Form.Select>
                        </div>
                        <div>
                          <Link
                            className={`sorting-icon ms-2`}
                            onClick={() => handleClickRotate("status")}
                          >
                            {sort.value === "asc" && (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                  fill="black"
                                />
                                <path
                                  d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                  fill="black"
                                  fillOpacity="0.5"
                                />
                              </svg>
                            )}

                            {sort.value === "desc" && (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                  fill="black"
                                  fillOpacity="0.5"
                                />
                                <path
                                  d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                          </Link>
                        </div>
                      </div>
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {guaranteeBasisList?.length > 0 ? (
                    guaranteeBasisList?.map((data, index) => (
                      <tr key={index}>
                        {/* <td>{(currentPage - 1) * 10 + (index + 1)}</td> */}
                        <td className="bold-font">{data.name}</td>
                        <td>{data.risk_name}</td>
                        <td>{data.conditions}</td>
                        <td>{data.amount_franchise}</td>
                        <td>{data.description}</td>
                        <td>
                          {data.status == 1 ? (
                            <span
                              className="verified badges"
                              onClick={() =>
                                handleStatusChange(data.id, data.status)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {t("activeLabel")}
                            </span>
                          ) : (
                            <span
                              className="incomplete badges"
                              onClick={() =>
                                handleStatusChange(data.id, data.status)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {t("inActiveLabel")}
                            </span>
                          )}
                        </td>
                        <td>
                          <div className="action-btn">
                            <Link
                              className="edit"
                              onClick={() => {
                                handleFormShowEdit();
                                setEditGuaranteeBasisId(data.id);
                              }}
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14.059 9.02L14.979 9.94L5.91902 19H4.99902V18.08L14.059 9.02ZM17.659 3C17.409 3 17.149 3.1 16.959 3.29L15.129 5.12L18.879 8.87L20.709 7.04C21.099 6.65 21.099 6.02 20.709 5.63L18.369 3.29C18.169 3.09 17.919 3 17.659 3ZM14.059 6.19L2.99902 17.25V21H6.74902L17.809 9.94L14.059 6.19Z"
                                  fill="#e84455"
                                />
                              </svg>
                            </Link>
                            <Link
                              className="delete"
                              onClick={() => {
                                handleShowDeleteModal();
                                setDeleteGuaranteeBasisId(data.id);
                              }}
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
                                  fill="#e84455"
                                />
                              </svg>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ textAlign: "center" }}>
                      <td colSpan="7">{t("NorecordsfoundLabel")}</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}
          {totalRecord > 10 && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              itemsPerPage={10}
              totalItems={totalRecord}
            />
          )}
        </div>
      </div>

      {/* Add Guarantee Basis  */}
      <AddGuaranteeBasis
        show={formShowAdd}
        onHide={handleFormCloseAdd}
        search={search}
        sort={sort}
        GuaranteeBasisList={GuaranteeBasisList}
      />

      {/* Edit Guarantee Basis  */}
      <EditGuaranteeBasis
        show={formShowEdit}
        onHide={handleFormCloseEdit}
        search={search}
        sort={sort}
        currentPage={currentPage}
        editGuaranteeBasisId={editGuaranteeBasisId}
        GuaranteeBasisList={GuaranteeBasisList}
      />

      {/* Confirmation Popup */}
      <Modal
        className="missing-doc-modal"
        show={showmodal}
        onHide={() => setShowmodal(true)}
      >
        <Modal.Header closeButton onHide={handleModalClose}>
          <Modal.Title>
            <h2>{t("confirmStatusTitle")}</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="complete-process">{t("confirmStatusMessage")}</span>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-end">
            <Button variant="primary" onClick={() => HandleUpdateStatus()}>
              {t("confirmbtnLabel")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Popup */}
      <Modal
        className="final-modal"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>Confirmation</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Êtes-vous sûr de vouloir supprimer le base de garantie ?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="cancel-btn"
            variant="primary"
            onClick={handleCloseDeleteModal}
          >
            Annuler
          </Button>
          <Button variant="primary" onClick={DeleteGuaranteeBasis}>
            {t("confirmbtnLabel")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default GuaranteeBasis;
